import { useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import { reloadBrutto } from 'features/views/bruttoProduction/actions';
import { getBruttoProductionList } from 'features/views/bruttoProduction/selectors';

import BruttoProductionTableRow from './BruttoProductionTableRow';

const BruttoProductionTable = () => {
	const dispatch = useDispatch();
	const bruttoProductionList = useSelector(getBruttoProductionList);

	const fetchStorePath = fetch.constants.urls.productionBruttoList;
	const fetchState = useSelector(fetch.selectors.getFetchState(fetchStorePath));

	const handleReload = useCallback(() => {
		dispatch(reloadBrutto());
	}, [dispatch]);

	return (
		<ComponentLoader fetchStorePath={fetchStorePath} onReload={handleReload}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>{getLabelMessage('bruttoProduction:contractNo')}</TableCell>
						<TableCell>{getLabelMessage('bruttoProduction:client')}</TableCell>
						<TableCell>
							<div>{getLabelMessage('bruttoProduction:importDateKCL')}</div>
							<div>{getLabelMessage('bruttoProduction:importDateBrutto')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('bruttoProduction:BpProduction')}</div>
							<div>{getLabelMessage('bruttoProduction:JpProduction')}</div>
						</TableCell>
						<TableCell>{getLabelMessage('bruttoProduction:businessShare')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{isEmpty(bruttoProductionList) ? (
						<TableHasNoResults fetchState={fetchState} />
					) : (
						bruttoProductionList.map((production) => <BruttoProductionTableRow production={production} />)
					)}
				</TableBody>
			</Table>
		</ComponentLoader>
	);
};

export default BruttoProductionTable;
